import React from 'react';
import Firebase from 'firebase';


export default class clientsItem extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    componentWillMount() {
        const contex = this;
        var clientRef = Firebase.database().ref('clients')
            .child(this.props.clientId)
            .once('value')
            .then(resp => { this.setState({ client: resp.val() }) });
        var numUsuarios = Firebase.database().ref('clients_users')
            .child(this.props.clientId)
            .once('value', function (snapshot) {
                contex.setState({ numUsuarios: snapshot.numChildren() });
            });
        var numStores = Firebase.database().ref('stores')
            .child(this.props.clientId)
            .once('value', function (snapshot) {
                contex.setState({ numStores: snapshot.numChildren() });
            })
        var formRef = Firebase.database().ref("forms");
        formRef
            .orderByChild('client_id')
            .equalTo(this.props.clientId)
            .once('value', function (snapshot) {
                contex.setState({ numForms: snapshot.numChildren() });
            })
    }

    render() {
        return (
            <tr>
                <td>
                    <div>
                        {this.props.client.name}
                    </div>
                    <div className="small text-muted" style={{cursor :"pointer"}}>
                        <span onClick={()=>{localStorage.setItem("client_id", this.props.clientId); this.props.verComo() }} >Ver como</span>
                    </div>
                </td>
                <td>{this.state.numForms}</td>
                <td>{this.state.numStores}</td>
                <td>{this.state.numUsuarios}</td>
                <td>
                    <span className="badge badge-success">Active</span>
                </td>
            </tr>
        )
    }
}


// WEBPACK FOOTER //
// ./src/views/administracion/clients/clientsItem.js